/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { memo, useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../locales/en-US/descriptors';
import './AllUtilitiesSavingsByMeterDetailComponent.scss';
import MeterSavingsDetailTable from '../../shared/MeterSavingsDetailTable/MeterSavingsDetailTable';
import {
  convertDataForSavingsMeter,
  getAllUtilityMeterDetails,
  getUtilityTypeMeterDetails
} from '../../shared/Utils/Utils';
import { IUtilityBillAllData } from '../UtilityBillViewDetailsComponent/IUtilityBillViewDetails';
import { UtilityMeterField, UtilityType } from '../../shared/Utils/Constants';
import { IDataTableColumn } from '../../shared/MeterSavingsDetailTable/IMeterSavingsDetailTableProps';
import { IMeterSavings } from '../../shared/SavingsMeter/SavingsMeterProps';
import { ApiContext } from '../../../context/ApiContext';
import { IAny } from '../../DashboardKPIWidgets/IEnergyManagementProps';

interface IAllUtilitiesSavingsByMeterDetailComponentProps {
  data: IUtilityBillAllData;
}

export const AllUtilitiesSavingsByMeterDetailComponent = (
  props: IAllUtilitiesSavingsByMeterDetailComponentProps
) => {
  const [t] = useTranslation();
  const d = descriptors.energyManagement;
  const { data } = props;

  const apiContext = useContext(ApiContext);
  const { userPreferedUnit } = apiContext;
  let fromUnit: string;
  // if (true) {
  //   fromUnit = userPreferedUnit as any;
  // } else {
  //   fromUnit = energyMeasurementUnit;
  // }

  fromUnit = userPreferedUnit as any;

  const {
    utilityCostCurrency,
    utilityMeasurementUnit,
    breakdownByUtility,
    utilityMeters
  } = data;

  const {
    meterSavingdata,
    utilityFromUnit,
    utilityToUnit
  } = convertDataForSavingsMeter(
    breakdownByUtility as IMeterSavings[],
    fromUnit
  );

  const utilityTypeMeterDetails = getUtilityTypeMeterDetails(
    utilityMeters,
    utilityToUnit,
    utilityFromUnit,
    fromUnit
  );

  const AllUtilitydetails = {
    meterSavingdata: meterSavingdata,
    utilityTypeMeterDetails: utilityTypeMeterDetails
  };

  const Utilitydetails = getAllUtilityMeterDetails(
    [AllUtilitydetails],
    apiContext.showChangeWhenData
  );

  const columnDetails: Array<IDataTableColumn> = [
    {
      className: 'datatable-column-meter',
      field: UtilityMeterField.type,
      header: t(d.METER),
      sortable: true,
      initialWidth: '10%'
    },
    {
      className: 'datatable-column-actualConsumption',
      field: UtilityMeterField.totalActualConsumption,
      header: t(d.actualCons),
      sortable: true,
      initialWidth: '15%'
    },
    {
      className: 'datatable-column-baselineConsumption',
      field: UtilityMeterField.previousPeriodConsumption,
      header: t(d.PREVIOUSPERIOD),
      sortable: true,
      initialWidth: '10%'
    },
    {
      className: 'datatable-column-percentageConsumptionSaving',
      field: UtilityMeterField.consumptionSavings,
      header: t(d.ConsumptionChange),
      sortable: true,
      initialWidth: '9%'
    },
    {
      className: 'datatable-column-actualCost',
      field: UtilityMeterField.totalActualCost,
      header: t(d.utiltactualCost),
      sortable: true,
      initialWidth: '15%'
    },
    {
      className: 'datatable-column-baselineCost',
      field: UtilityMeterField.previousPeriodCost,
      header: t(d.utilpreviousCost),
      sortable: true,
      initialWidth: '9%'
    },
    {
      className: 'datatable-column-percentageCostSavings',
      field: UtilityMeterField.costSavings,
      header: t(d.utilchange),
      sortable: true,
      initialWidth: '8.5%'
    }
  ];

  return (
    <div className="emaas-Metersaving-details-head">
      <MeterSavingsDetailTable
        meterData={Utilitydetails as IAny}
        utilityCostCurrency={utilityCostCurrency}
        utilityMeasurementUnit={utilityMeasurementUnit}
        columnDetails={columnDetails}
        utilityType={UtilityType.All}
      />
    </div>
  );
};
export default memo(AllUtilitiesSavingsByMeterDetailComponent);
